import { FormButtonController } from './form-button.controller';
import template from './form-button.html';

export const uiFormButtonComponent = {
  name: 'uiFormButton',
  restrict: 'E',
  template,
  transclude: true,
  controllerAs: 'vm',
  controller: FormButtonController,
  bindings: {
    onClick: '&',
    onLongPress: '&',
    label: '@',
    labelValues: '<',
    icon: '@',
    isBusy: '<',
    isDisabled: '<',
    isActive: '<',
    testId: '@',
    btnType: '@',
    btnTypeClass: '@',
    btnDefault: '@',
    btnPrimary: '@',
    btnSuccess: '@',
    btnInfo: '@',
    btnWarning: '@',
    btnDanger: '@',
    btnLink: '@',
    btnLarge: '@',
    btnBlock: '@',
    btnClass: '@',
  },
};
